export const colors = {
  background: '#000000', // Main background (pure black)
  foreground: '#F4F4F5', // Main text (light)
  primary: '#FA8B14', // Accent orange (unchanged)
  primary_foreground: '#18181B', // On primary (dark for contrast)
  secondary: '#1a1a1a', // Very dark gray for contrast
  secondary_foreground: '#E5E5E5', // Light text for secondary
  muted: '#1a1a1a', // Muted background (very dark gray)
  muted_foreground: '#A1A1AA', // Muted text
  accent: '#1a1a1a', // Accent background (very dark gray)
  accent_foreground: '#FAFAFA', // Accent text (white)
  destructive: '#EF1F53', // Red for errors
  destructive_foreground: '#FAFAFA', // On error (white)
  card: '#1a1a1a', // Card background (very dark gray for contrast)
  card_foreground: '#F4F4F5', // Card text (light)
  popover: '#1a1a1a', // Popover background (very dark gray)
  popover_foreground: '#F4F4F5', // Popover text (light)
  border: 'rgba(255,255,255,0.07)', // Subtle border for dark theme
  input: '#1a1a1a', // Input background (very dark gray)
  ring: '#FA8B14', // Focus ring (accent)
  sidebar_background: '#000000', // Sidebar background (pure black)
  sidebar_foreground: '#F4F4F5', // Sidebar text (light)
  sidebar_primary: '#1a1a1a', // Sidebar primary (very dark gray)
  sidebar_primary_foreground: '#FAFAFA', // Sidebar primary text (white)
  sidebar_accent: '#1a1a1a', // Sidebar accent (very dark gray)
  sidebar_accent_foreground: '#FAFAFA', // Sidebar accent text (white)
  sidebar_border: 'rgba(255,255,255,0.07)', // Subtle sidebar border for dark theme
  sidebar_ring: '#FA8B14', // Sidebar focus ring (accent)
  black: '#0e0e0e',
};

export default colors;
